import http from "./httpService";

const baseUrl = `/settings`;

export const getSettings = async () => {
  try {
    const { data } = await http.get(baseUrl);
    return data.settings;
  } catch (err) {
    return null;
  }
};

export const updateSettings = async (payload) => {
  try {
    const { status, data } = await http.put(baseUrl, payload);
    return { status, settings: data.settings, message: data.message };
  } catch (err) {
    return {};
  }
};
